// Single source of truth for ALL public, indexable routes.
// Used by:
//   - src/components/Footer.tsx  (renders real internal <a> links so Google can crawl)
//   - scripts/generate-sitemap.ts (writes public/sitemap.xml)
//
// Add new public pages HERE — they will automatically appear in the footer
// navigation AND the sitemap. Do NOT include admin / auth / 404 routes.

export interface SiteRoute {
  /** URL path, e.g. "/blog" */
  path: string;
  /** Human label for footer nav */
  label: string;
  /** Sitemap priority (0.0 - 1.0) */
  priority: string;
  /** Sitemap change frequency */
  changefreq:
    | "always"
    | "hourly"
    | "daily"
    | "weekly"
    | "monthly"
    | "yearly"
    | "never";
}

export const SITE_ROUTES: SiteRoute[] = [
  { path: "/",             label: "Home",         priority: "1.0", changefreq: "weekly"  },
  { path: "/blog",         label: "Blog",         priority: "0.9", changefreq: "weekly"  },
  { path: "/achievements", label: "Achievements", priority: "0.8", changefreq: "monthly" },
  { path: "/contact",      label: "Contact",      priority: "0.8", changefreq: "monthly" },
  { path: "/donate",       label: "Donate",       priority: "0.7", changefreq: "monthly" },
  { path: "/goals",        label: "Goals",        priority: "0.6", changefreq: "monthly" },
  { path: "/nfc",          label: "Digital Card", priority: "0.7", changefreq: "monthly" },
  { path: "/gallery",      label: "Gallery",      priority: "0.8", changefreq: "weekly"  },
  { path: "/anonymous",    label: "Anonymous",    priority: "0.6", changefreq: "weekly"  },
];
